<template>
  <div class="wincourse-guide">
    <img :src="url" alt="">
  </div>
</template>
<script>
export default {
  data() {
    return {
      url: require("@/assets/imgs/wincourse/base-course.png"),
    };
  },
};
</script>
<style lang="less" scoped>
.wincourse-guide {
  width: 100%;
  img {
    width: 100%;
  }
}
</style>
